import { getText } from '../../../i18n';

const ClientOptionButtons = ({ handleCancel, handleSave }) => {
    return (
        <div
            className={`d-flex justify-content-evenly mt-5`}
        >
            <button
                type="button"
                onClick={handleCancel}
                className="ing-popup-blue-negative"
            >
                {getText('msg_77dfd2135f4d')}
            </button>
            <button
                type="button"
                className="ing-button-primary-none"
                onClick={handleSave}
            >
                {getText('msg_efc007a393f6')}
            </button>
        </div>)
}

export default ClientOptionButtons;
